// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file chat/v3/chat_messages.proto (package chat.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { MessageErrorData, MessageLimitData, MessagePingData, MessageRetryData, MessageWarningData } from "./chat_messages_system_pb";
import { file_chat_v3_chat_messages_system } from "./chat_messages_system_pb";
import type { EnabledTools, PromptAttachment, PromptMode, SuggestionAttribution, VendorPreference, VendorStrategy } from "./chat_prompt_pb";
import { file_chat_v3_chat_prompt } from "./chat_prompt_pb";
import type { RichText } from "./chat_rich_text_pb";
import { file_chat_v3_chat_rich_text } from "./chat_rich_text_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Icon } from "../../common/v3/icons_pb";
import { file_common_v3_icons } from "../../common/v3/icons_pb";
import type { Feature } from "../../entitlements/v3/features_pb";
import { file_entitlements_v3_features } from "../../entitlements/v3/features_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Scope } from "../../query/v3/scope_pb";
import { file_query_v3_scope } from "../../query/v3/scope_pb";
import type { Message as Message$1 } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v3/chat_messages.proto.
 */
export const file_chat_v3_chat_messages: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chat_v3_chat_messages_system, file_chat_v3_chat_prompt, file_chat_v3_chat_rich_text, file_common_v3_common, file_common_v3_icons, file_entitlements_v3_features, file_google_protobuf_duration, file_google_protobuf_timestamp, file_query_v3_scope]);

/**
 * @generated from message chat.v3.Message
 */
export type Message = Message$1<"chat.v3.Message"> & {
  /**
   * Event discriminator for the message. This is used to determine the type of
   * event being sent.
   *
   * @generated from field: chat.v3.Event event = 1;
   */
  event: Event;

  /**
   * ID of the message.
   * Format: ^message_[a-z0-9]{20}$
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * The index of the message in the conversation. Used to distinguish
   * contiguous messages as additional events are streamed.
   *
   * @generated from field: int32 index = 3;
   */
  index: number;

  /**
   * Unique identifier for the block (part).
   *
   * @generated from field: string block_id = 4;
   */
  blockId: string;

  /**
   * @generated from field: string operation_id = 5;
   */
  operationId: string;

  /**
   * The role of the message sender.
   *
   * @generated from field: chat.v3.Role role = 6;
   */
  role: Role;

  /**
   * Activity is an optional field that can be used to provide additional
   * data. This may be sent on a start message.
   *
   * @generated from field: optional string activity = 7;
   */
  activity?: string;

  /**
   * The number of tokens received from the model.
   *
   * @generated from field: uint64 ingress_tokens = 8;
   */
  ingressTokens: bigint;

  /**
   * The number of tokens sent to the model.
   *
   * @generated from field: uint64 egress_tokens = 9;
   */
  egressTokens: bigint;

  /**
   * The number of ingress bytes received for the operation, which may include
   * source materials or other data not provided by a model.
   *
   * @generated from field: uint64 ingress_bytes = 11;
   */
  ingressBytes: bigint;

  /**
   * The number of egress bytes sent for the operation, which may include
   * the response or other data not provided by a model.
   *
   * @generated from field: uint64 egress_bytes = 12;
   */
  egressBytes: bigint;

  /**
   * Data associated with the message.
   *
   * @generated from oneof chat.v3.Message.data
   */
  data: {
    /**
     * @generated from field: chat.v3.MessagePingData message_ping_data = 13;
     */
    value: MessagePingData;
    case: "messagePingData";
  } | {
    /**
     * @generated from field: chat.v3.MessageErrorData message_error_data = 14;
     */
    value: MessageErrorData;
    case: "messageErrorData";
  } | {
    /**
     * @generated from field: chat.v3.MessageWarningData message_warning_data = 15;
     */
    value: MessageWarningData;
    case: "messageWarningData";
  } | {
    /**
     * @generated from field: chat.v3.MessageLimitData message_limit_data = 16;
     */
    value: MessageLimitData;
    case: "messageLimitData";
  } | {
    /**
     * @generated from field: chat.v3.MessageStartData message_start_data = 17;
     */
    value: MessageStartData;
    case: "messageStartData";
  } | {
    /**
     * @generated from field: chat.v3.MessageDeltaData message_delta_data = 18;
     */
    value: MessageDeltaData;
    case: "messageDeltaData";
  } | {
    /**
     * @generated from field: chat.v3.MessageDeltaHeartbeatData message_delta_heartbeat_data = 19;
     */
    value: MessageDeltaHeartbeatData;
    case: "messageDeltaHeartbeatData";
  } | {
    /**
     * @generated from field: chat.v3.MessageData message_data = 20;
     */
    value: MessageData;
    case: "messageData";
  } | {
    /**
     * @generated from field: chat.v3.MessageStopData message_stop_data = 21;
     */
    value: MessageStopData;
    case: "messageStopData";
  } | {
    /**
     * @generated from field: chat.v3.MessageTaskData message_task_data = 22;
     */
    value: MessageTaskData;
    case: "messageTaskData";
  } | {
    /**
     * @generated from field: chat.v3.MessageOperationStatusData message_operation_status_data = 23;
     */
    value: MessageOperationStatusData;
    case: "messageOperationStatusData";
  } | {
    /**
     * @generated from field: chat.v3.MessageInsightData message_insight_data = 24;
     */
    value: MessageInsightData;
    case: "messageInsightData";
  } | {
    /**
     * @generated from field: chat.v3.MessageRetryData message_retry_data = 28;
     */
    value: MessageRetryData;
    case: "messageRetryData";
  } | { case: undefined; value?: undefined };

  /**
   * The number of credits consumed for the tokens in this message.
   *
   * @generated from field: int64 egress_credits = 25;
   */
  egressCredits: bigint;

  /**
   * @generated from field: int64 ingress_credits = 26;
   */
  ingressCredits: bigint;

  /**
   * @generated from field: int64 credits_total = 27;
   */
  creditsTotal: bigint;
};

/**
 * Describes the message chat.v3.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 0);

/**
 * MessageStartData represents the data associated with the start of a message.
 *
 * @generated from message chat.v3.MessageStartData
 */
export type MessageStartData = Message$1<"chat.v3.MessageStartData"> & {
  /**
   * Format: ^message_[a-z0-9]{20}$
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The role of the message sender
   *
   * @generated from field: chat.v3.Role role = 2;
   */
  role: Role;

  /**
   * Message type indicates the type of message being started.
   *
   * @generated from field: chat.v3.MessageType message_type = 3;
   */
  messageType: MessageType;

  /**
   * Feature processing the message. Typically a model or tool call.
   *
   * @generated from field: entitlements.v3.Feature feature = 4;
   */
  feature: Feature;

  /**
   * An optional title for the message (or block).
   *
   * @generated from field: optional string title = 5;
   */
  title?: string;

  /**
   * The prompt text we are processing
   *
   * @generated from field: string prompt_text = 6;
   */
  promptText: string;

  /**
   * An initial icon representing the message
   *
   * @generated from field: common.v3.Icon icon = 7;
   */
  icon: Icon;

  /**
   * @generated from field: uint64 ingress_tokens = 8;
   */
  ingressTokens: bigint;

  /**
   * @generated from field: uint64 ingress_bytes = 9;
   */
  ingressBytes: bigint;

  /**
   * @generated from field: int64 ingress_credits = 10;
   */
  ingressCredits: bigint;

  /**
   * The prompt rich text we are processing
   *
   * @generated from field: optional chat.v3.RichText prompt_rich_text = 11;
   */
  promptRichText?: RichText;

  /**
   * @generated from field: string tenant_id = 12;
   */
  tenantId: string;

  /**
   * @generated from field: string organization_id = 13;
   */
  organizationId: string;

  /**
   * @generated from field: string workspace_id = 14;
   */
  workspaceId: string;

  /**
   * @generated from field: string project_id = 15;
   */
  projectId: string;

  /**
   * @generated from field: string user_id = 16;
   */
  userId: string;

  /**
   * @generated from field: string chat_id = 17;
   */
  chatId: string;

  /**
   * Optional scope of the message; typically used with a MESSAGE_START to
   * ack the scope back to the client or allow re-populating the latest scope
   * when returning to a previous chat.
   *
   * @generated from field: optional query.v3.Scope scope = 18;
   */
  scope?: Scope;

  /**
   * Attribution for suggestion prompts, tracking which persona and category
   * generated the suggestion that was selected.
   *
   * @generated from field: optional chat.v3.SuggestionAttribution suggestion_attribution = 19;
   */
  suggestionAttribution?: SuggestionAttribution;

  /**
   * The resolved prompt mode used for this message. When the user selects
   * AUTO, this contains the mode that was actually resolved to.
   *
   * @generated from field: optional chat.v3.PromptMode resolved_mode = 20;
   */
  resolvedMode?: PromptMode;

  /**
   * The email of the user who created this message. Persisted with the
   * message to avoid requiring a user lookup at display time.
   *
   * @generated from field: string user_email = 21;
   */
  userEmail: string;

  /**
   * The parent message ID for branching.
   *
   * @generated from field: optional string parent_message_id = 23;
   */
  parentMessageId?: string;

  /**
   * Skills pre-loaded before LLM execution (e.g. respond-as persona).
   * Echoed from the original ChatPrompt so clients can display the voice
   * used for this message without client-side injection.
   *
   * @generated from field: repeated string pre_loaded_skills = 24;
   */
  preLoadedSkills: string[];

  /**
   * User-facing tool overrides for this prompt. Fields set to true mean the
   * tool was explicitly disabled by the user. Echoed from ChatPrompt so
   * clients can show the public-data / web-search status on history reload.
   *
   * @generated from field: optional chat.v3.EnabledTools disabled_tools = 25;
   */
  disabledTools?: EnabledTools;

  /**
   * The mode AUTO wanted for this message but could not serve — the plan
   * doesn't grant it, or the balance is below the floor auto spends unprompted.
   * resolved_mode holds what actually ran. Echoed from ChatPrompt so the
   * upgrade nudge survives a history reload.
   *
   * @generated from field: optional chat.v3.PromptMode capped_from_mode = 26;
   */
  cappedFromMode?: PromptMode;

  /**
   * The picker selection this message was submitted under, echoed from
   * ChatPrompt because the Prompt itself is never persisted — the recording
   * blob is the only per-message record a client can reload, so a field absent
   * here is a field the picker cannot rehydrate.
   *
   * selected_mode is what the user chose, resolved_mode what the router ran. A
   * client hydrating its picker reads selected_mode; reading resolved_mode
   * would silently promote an AUTO chat into whichever tier its first turn
   * classified to.
   *
   * @generated from field: optional chat.v3.PromptMode selected_mode = 27;
   */
  selectedMode?: PromptMode;

  /**
   * @generated from field: optional chat.v3.VendorPreference vendor_preference = 28;
   */
  vendorPreference?: VendorPreference;

  /**
   * @generated from field: optional chat.v3.VendorStrategy vendor_strategy = 29;
   */
  vendorStrategy?: VendorStrategy;

  /**
   * @generated from field: entitlements.v3.Feature preferred_model = 30;
   */
  preferredModel: Feature;

  /**
   * The model the router resolved and served for this turn (prompt.model after
   * mode resolution). Persisted so a retry can read which model — and vendor —
   * served a failed turn and reroute away from it. Distinct from preferred_model
   * (the user's pin) and feature (the fixed agent feature).
   *
   * @generated from field: entitlements.v3.Feature resolved_model = 31;
   */
  resolvedModel: Feature;

  /**
   * Set only on a rerouted retry turn whose served model (resolved_model) differs
   * from the model the failed turn's error card promised (its
   * suggested_retry_model). Lets the client render "Routed to {resolved_model} —
   * {reroute_promised_model} wasn't available" from the retried turn alone. Unset
   * everywhere else.
   *
   * @generated from field: entitlements.v3.Feature reroute_promised_model = 32;
   */
  reroutePromisedModel: Feature;

  /**
   * Echoed from ChatPrompt so a reloaded history renders the attachment
   * previews and later turns can replay the files to the model.
   *
   * @generated from field: repeated chat.v3.PromptAttachment attachments = 33;
   */
  attachments: PromptAttachment[];
};

/**
 * Describes the message chat.v3.MessageStartData.
 * Use `create(MessageStartDataSchema)` to create a new message.
 */
export const MessageStartDataSchema: GenMessage<MessageStartData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 1);

/**
 * MessageDeltaData represents the data associated with a delta message.
 * which is a partial update to a text message.
 *
 * @generated from message chat.v3.MessageDeltaData
 */
export type MessageDeltaData = Message$1<"chat.v3.MessageDeltaData"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message chat.v3.MessageDeltaData.
 * Use `create(MessageDeltaDataSchema)` to create a new message.
 */
export const MessageDeltaDataSchema: GenMessage<MessageDeltaData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 2);

/**
 * MessageDeltaHeartbeatData represents the data associated with a temporary
 * delta message. This is used to provide a temporary update that can be
 * removed by a client when a stop delta message is received.
 *
 * For example, a tool that does not the ability so stream tokens may send
 * progress updates on a timer using this message type. The client may then
 * remove them when the final message is received and we have
 * user-facing content.
 *
 * @generated from message chat.v3.MessageDeltaHeartbeatData
 */
export type MessageDeltaHeartbeatData = Message$1<"chat.v3.MessageDeltaHeartbeatData"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message chat.v3.MessageDeltaHeartbeatData.
 * Use `create(MessageDeltaHeartbeatDataSchema)` to create a new message.
 */
export const MessageDeltaHeartbeatDataSchema: GenMessage<MessageDeltaHeartbeatData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 3);

/**
 * MessageData represents the data associated with completed message.
 *
 * @generated from message chat.v3.MessageData
 */
export type MessageData = Message$1<"chat.v3.MessageData"> & {
  /**
   * @generated from oneof chat.v3.MessageData.content
   */
  content: {
    /**
     * @generated from field: string text = 1;
     */
    value: string;
    case: "text";
  } | {
    /**
     * @generated from field: chat.v3.RichText rich_text = 2;
     */
    value: RichText;
    case: "richText";
  } | { case: undefined; value?: undefined };

  /**
   * Allow messages to share LLM telemetry data
   *
   * @generated from field: repeated chat.v3.FeatureMetricsSet metrics = 100;
   */
  metrics: FeatureMetricsSet[];

  /**
   * Allow messages to share structured data on search results
   *
   * @generated from field: optional chat.v3.SearchResult search_results = 101;
   */
  searchResults?: SearchResult;

  /**
   * Allow billing data to be attached to messages
   *
   * @generated from field: optional chat.v3.CreditStatement credit_statement = 102;
   */
  creditStatement?: CreditStatement;

  /**
   * Allow messages to share structured web search results
   *
   * @generated from field: optional chat.v3.WebSearchResult web_search_results = 103;
   */
  webSearchResults?: WebSearchResult;

  /**
   * Allow messages to share structured concept results
   *
   * @generated from field: optional chat.v3.ConceptResult concept_results = 104;
   */
  conceptResults?: ConceptResult;

  /**
   * Allow messages to share structured data results
   *
   * @generated from field: optional chat.v3.StructuredDataResult structured_results = 105;
   */
  structuredResults?: StructuredDataResult;

  /**
   * Allow messages to share image generation results
   *
   * @generated from field: optional chat.v3.ImageResult image_results = 106;
   */
  imageResults?: ImageResult;
};

/**
 * Describes the message chat.v3.MessageData.
 * Use `create(MessageDataSchema)` to create a new message.
 */
export const MessageDataSchema: GenMessage<MessageData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 4);

/**
 * MessageStopData represents the data associated with a message stop event.
 * This includes accounting information for ingress and egress bytes and tokens
 * by feature when the message processing is complete.
 *
 * @generated from message chat.v3.MessageStopData
 */
export type MessageStopData = Message$1<"chat.v3.MessageStopData"> & {
  /**
   * Metrics grouped by feature (model, tool, etc.)
   *
   * @generated from field: map<string, chat.v3.FeatureMetrics> feature_metrics = 1;
   */
  featureMetrics: { [key: string]: FeatureMetrics };
};

/**
 * Describes the message chat.v3.MessageStopData.
 * Use `create(MessageStopDataSchema)` to create a new message.
 */
export const MessageStopDataSchema: GenMessage<MessageStopData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 5);

/**
 * @generated from message chat.v3.CreditStatement
 */
export type CreditStatement = Message$1<"chat.v3.CreditStatement"> & {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance: bigint;

  /**
   * @generated from field: repeated chat.v3.Debit debits = 2;
   */
  debits: Debit[];
};

/**
 * Describes the message chat.v3.CreditStatement.
 * Use `create(CreditStatementSchema)` to create a new message.
 */
export const CreditStatementSchema: GenMessage<CreditStatement> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 6);

/**
 * @generated from message chat.v3.Debit
 */
export type Debit = Message$1<"chat.v3.Debit"> & {
  /**
   * @generated from field: string activity = 1;
   */
  activity: string;

  /**
   * @generated from field: string operation_id = 2;
   */
  operationId: string;

  /**
   * @generated from field: chat.v3.FeatureMetricsSet metrics = 3;
   */
  metrics?: FeatureMetricsSet;
};

/**
 * Describes the message chat.v3.Debit.
 * Use `create(DebitSchema)` to create a new message.
 */
export const DebitSchema: GenMessage<Debit> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 7);

/**
 * @generated from message chat.v3.FeatureMetricsSet
 */
export type FeatureMetricsSet = Message$1<"chat.v3.FeatureMetricsSet"> & {
  /**
   * @generated from field: entitlements.v3.Feature feature = 1;
   */
  feature: Feature;

  /**
   * @generated from field: chat.v3.FeatureMetrics metrics = 2;
   */
  metrics?: FeatureMetrics;

  /**
   * @generated from field: chat.v3.FeatureTokens feature_tokens = 3;
   */
  featureTokens?: FeatureTokens;
};

/**
 * Describes the message chat.v3.FeatureMetricsSet.
 * Use `create(FeatureMetricsSetSchema)` to create a new message.
 */
export const FeatureMetricsSetSchema: GenMessage<FeatureMetricsSet> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 8);

/**
 * @generated from message chat.v3.FeatureTokens
 */
export type FeatureTokens = Message$1<"chat.v3.FeatureTokens"> & {
  /**
   * @generated from field: chat.v3.FeatureTokenType type = 1;
   */
  type: FeatureTokenType;

  /**
   * @generated from field: int64 ingress_credits = 2;
   */
  ingressCredits: bigint;

  /**
   * @generated from field: int64 egress_credits = 3;
   */
  egressCredits: bigint;

  /**
   * @generated from field: int64 total_credits = 4;
   */
  totalCredits: bigint;
};

/**
 * Describes the message chat.v3.FeatureTokens.
 * Use `create(FeatureTokensSchema)` to create a new message.
 */
export const FeatureTokensSchema: GenMessage<FeatureTokens> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 9);

/**
 * @generated from message chat.v3.SearchResult
 */
export type SearchResult = Message$1<"chat.v3.SearchResult"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: google.protobuf.Duration duration = 5;
   */
  duration?: Duration;

  /**
   * @generated from oneof chat.v3.SearchResult.results
   */
  results: {
    /**
     * @generated from field: chat.v3.AssetSearchResults assets = 2;
     */
    value: AssetSearchResults;
    case: "assets";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: string tool_id = 10;
   */
  toolId: string;

  /**
   * @generated from field: int32 total_results = 11;
   */
  totalResults: number;
};

/**
 * Describes the message chat.v3.SearchResult.
 * Use `create(SearchResultSchema)` to create a new message.
 */
export const SearchResultSchema: GenMessage<SearchResult> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 10);

/**
 * @generated from message chat.v3.AssetSearchResults
 */
export type AssetSearchResults = Message$1<"chat.v3.AssetSearchResults"> & {
  /**
   * @generated from field: repeated chat.v3.AssetSearchResultItem assets = 1;
   */
  assets: AssetSearchResultItem[];
};

/**
 * Describes the message chat.v3.AssetSearchResults.
 * Use `create(AssetSearchResultsSchema)` to create a new message.
 */
export const AssetSearchResultsSchema: GenMessage<AssetSearchResults> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 11);

/**
 * @generated from message chat.v3.AssetSearchResultItem
 */
export type AssetSearchResultItem = Message$1<"chat.v3.AssetSearchResultItem"> & {
  /**
   * @generated from field: string asset_id = 1 [json_name = "id"];
   */
  assetId: string;

  /**
   * Backward compatibility
   *
   * @generated from field: string filename = 2 [json_name = "originalFilename"];
   */
  filename: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * Backward compatibility
   *
   * @generated from field: string asset_type = 4 [json_name = "type"];
   */
  assetType: string;

  /**
   * @generated from field: repeated chat.v3.ChunkResult chunks = 5;
   */
  chunks: ChunkResult[];

  /**
   * @generated from field: double relevance_score = 6;
   */
  relevanceScore: number;

  /**
   * @generated from field: uint64 size_bytes = 7;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: string url = 8;
   */
  url: string;

  /**
   * @generated from field: string summary = 9;
   */
  summary: string;
};

/**
 * Describes the message chat.v3.AssetSearchResultItem.
 * Use `create(AssetSearchResultItemSchema)` to create a new message.
 */
export const AssetSearchResultItemSchema: GenMessage<AssetSearchResultItem> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 12);

/**
 * @generated from message chat.v3.ChunkResult
 */
export type ChunkResult = Message$1<"chat.v3.ChunkResult"> & {
  /**
   * @generated from field: string chunk_id = 1;
   */
  chunkId: string;

  /**
   * @generated from field: int32 position = 2;
   */
  position: number;

  /**
   * @generated from field: string content = 3;
   */
  content: string;

  /**
   * @generated from field: double score = 4;
   */
  score: number;

  /**
   * @generated from field: optional chat.v3.ChunkLocation location = 5;
   */
  location?: ChunkLocation;
};

/**
 * Describes the message chat.v3.ChunkResult.
 * Use `create(ChunkResultSchema)` to create a new message.
 */
export const ChunkResultSchema: GenMessage<ChunkResult> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 13);

/**
 * @generated from message chat.v3.ChunkLocation
 */
export type ChunkLocation = Message$1<"chat.v3.ChunkLocation"> & {
  /**
   * @generated from field: int32 page_number = 1;
   */
  pageNumber: number;

  /**
   * @generated from field: string marker_id = 2;
   */
  markerId: string;
};

/**
 * Describes the message chat.v3.ChunkLocation.
 * Use `create(ChunkLocationSchema)` to create a new message.
 */
export const ChunkLocationSchema: GenMessage<ChunkLocation> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 14);

/**
 * @generated from message chat.v3.AssetSummary
 */
export type AssetSummary = Message$1<"chat.v3.AssetSummary"> & {
  /**
   * The unique identifier for the asset
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The human-readable name of the asset
   *
   * @generated from field: string original_filename = 2;
   */
  originalFilename: string;

  /**
   * System generated name
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * The type of asset (e.g., "image", "audio", "document")
   *
   * @generated from field: string type = 4;
   */
  type: string;

  /**
   * The size of the asset in bytes
   *
   * @generated from field: uint64 size_bytes = 5;
   */
  sizeBytes: bigint;

  /**
   * The URL where the asset can be accessed
   *
   * @generated from field: string url = 6;
   */
  url: string;

  /**
   * Summary of the asset
   *
   * @generated from field: string summary = 7;
   */
  summary: string;
};

/**
 * Describes the message chat.v3.AssetSummary.
 * Use `create(AssetSummarySchema)` to create a new message.
 */
export const AssetSummarySchema: GenMessage<AssetSummary> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 15);

/**
 * WebSearchResult represents structured web search results
 *
 * @generated from message chat.v3.WebSearchResult
 */
export type WebSearchResult = Message$1<"chat.v3.WebSearchResult"> & {
  /**
   * The original search query (optional to support direct URL fetching)
   *
   * @generated from field: optional string query = 1;
   */
  query?: string;

  /**
   * How long the search took to complete
   *
   * @generated from field: google.protobuf.Duration duration = 2;
   */
  duration?: Duration;

  /**
   * The individual search results
   *
   * @generated from field: repeated chat.v3.WebSearchResultItem results = 3;
   */
  results: WebSearchResultItem[];

  /**
   * The total number of search results found
   *
   * @generated from field: int32 total_results = 4;
   */
  totalResults: number;

  /**
   * The unique tool identifier for citation purposes
   *
   * @generated from field: string tool_id = 5;
   */
  toolId: string;
};

/**
 * Describes the message chat.v3.WebSearchResult.
 * Use `create(WebSearchResultSchema)` to create a new message.
 */
export const WebSearchResultSchema: GenMessage<WebSearchResult> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 16);

/**
 * WebSearchResultItem represents a single web search result
 *
 * @generated from message chat.v3.WebSearchResultItem
 */
export type WebSearchResultItem = Message$1<"chat.v3.WebSearchResultItem"> & {
  /**
   * The URL of the search result
   *
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * The title of the search result
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * The content snippet from the search result
   *
   * @generated from field: string text = 3;
   */
  text: string;

  /**
   * The URL to the site's favicon for display
   *
   * @generated from field: string favicon_url = 4;
   */
  faviconUrl: string;

  /**
   * The relevance score from the search provider
   *
   * @generated from field: double score = 5;
   */
  score: number;

  /**
   * The 1-based index of this result in the search results
   *
   * @generated from field: int32 index = 6;
   */
  index: number;

  /**
   * The publication date of the content (RFC3339 format)
   *
   * @generated from field: string published_date = 7;
   */
  publishedDate: string;

  /**
   * The author of the content
   *
   * @generated from field: string author = 8;
   */
  author: string;

  /**
   * Optional summary of the webpage content
   *
   * @generated from field: optional string summary = 9;
   */
  summary?: string;
};

/**
 * Describes the message chat.v3.WebSearchResultItem.
 * Use `create(WebSearchResultItemSchema)` to create a new message.
 */
export const WebSearchResultItemSchema: GenMessage<WebSearchResultItem> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 17);

/**
 * ConceptResult represents structured concept loading results
 *
 * @generated from message chat.v3.ConceptResult
 */
export type ConceptResult = Message$1<"chat.v3.ConceptResult"> & {
  /**
   * The total number of concepts loaded
   *
   * @generated from field: int32 total_concepts = 1;
   */
  totalConcepts: number;

  /**
   * How long the loading took
   *
   * @generated from field: google.protobuf.Duration duration = 2;
   */
  duration?: Duration;

  /**
   * The individual concept summaries
   *
   * @generated from field: repeated chat.v3.ConceptSummary concepts = 3;
   */
  concepts: ConceptSummary[];
};

/**
 * Describes the message chat.v3.ConceptResult.
 * Use `create(ConceptResultSchema)` to create a new message.
 */
export const ConceptResultSchema: GenMessage<ConceptResult> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 18);

/**
 * StructuredDataResult represents structured data query results (CSV/spreadsheet)
 *
 * @generated from message chat.v3.StructuredDataResult
 */
export type StructuredDataResult = Message$1<"chat.v3.StructuredDataResult"> & {
  /**
   * Asset information
   *
   * @generated from field: string asset_id = 1;
   */
  assetId: string;

  /**
   * @generated from field: string asset_name = 2;
   */
  assetName: string;

  /**
   * Query metadata
   *
   * e.g., "Result 1 of 5"
   *
   * @generated from field: int32 query_index = 3;
   */
  queryIndex: number;

  /**
   * @generated from field: int32 total_queries = 4;
   */
  totalQueries: number;

  /**
   * Table data
   *
   * Column headers
   *
   * @generated from field: repeated string headers = 5;
   */
  headers: string[];

  /**
   * Data rows
   *
   * @generated from field: repeated chat.v3.RowData rows = 6;
   */
  rows: RowData[];

  /**
   * @generated from field: int32 row_count = 7;
   */
  rowCount: number;

  /**
   * Completion message fields
   *
   * @generated from field: bool is_completion = 8;
   */
  isCompletion: boolean;

  /**
   * @generated from field: google.protobuf.Duration duration = 9;
   */
  duration?: Duration;

  /**
   * @generated from field: int32 asset_count = 10;
   */
  assetCount: number;

  /**
   * Query reasoning - explains why this SQL query was chosen
   *
   * @generated from field: string query_reason = 11;
   */
  queryReason: string;

  /**
   * The natural language query that generated these results
   *
   * @generated from field: string query = 12;
   */
  query: string;

  /**
   * Citation fields
   *
   * @generated from field: string tool_id = 20;
   */
  toolId: string;

  /**
   * @generated from field: string citation_id = 21;
   */
  citationId: string;
};

/**
 * Describes the message chat.v3.StructuredDataResult.
 * Use `create(StructuredDataResultSchema)` to create a new message.
 */
export const StructuredDataResultSchema: GenMessage<StructuredDataResult> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 19);

/**
 * RowData represents a single row of structured data
 *
 * @generated from message chat.v3.RowData
 */
export type RowData = Message$1<"chat.v3.RowData"> & {
  /**
   * @generated from field: repeated string values = 1;
   */
  values: string[];
};

/**
 * Describes the message chat.v3.RowData.
 * Use `create(RowDataSchema)` to create a new message.
 */
export const RowDataSchema: GenMessage<RowData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 20);

/**
 * ImageResult represents generated image data from image generation tools
 *
 * @generated from message chat.v3.ImageResult
 */
export type ImageResult = Message$1<"chat.v3.ImageResult"> & {
  /**
   * Storage location in GCS (persisted in DB)
   *
   * @generated from field: chat.v3.ImageStorageLocation storage_location = 1;
   */
  storageLocation?: ImageStorageLocation;

  /**
   * Tool ID for tracking and citations
   *
   * @generated from field: string tool_id = 2;
   */
  toolId: string;

  /**
   * Metadata about the image generation
   *
   * @generated from field: chat.v3.ImageMetadata metadata = 3;
   */
  metadata?: ImageMetadata;
};

/**
 * Describes the message chat.v3.ImageResult.
 * Use `create(ImageResultSchema)` to create a new message.
 */
export const ImageResultSchema: GenMessage<ImageResult> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 21);

/**
 * ImageStorageLocation identifies where an image is stored in GCS
 *
 * @generated from message chat.v3.ImageStorageLocation
 */
export type ImageStorageLocation = Message$1<"chat.v3.ImageStorageLocation"> & {
  /**
   * @generated from field: string bucket = 1;
   */
  bucket: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;
};

/**
 * Describes the message chat.v3.ImageStorageLocation.
 * Use `create(ImageStorageLocationSchema)` to create a new message.
 */
export const ImageStorageLocationSchema: GenMessage<ImageStorageLocation> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 22);

/**
 * ImageMetadata contains additional information about the generated image
 *
 * @generated from message chat.v3.ImageMetadata
 */
export type ImageMetadata = Message$1<"chat.v3.ImageMetadata"> & {
  /**
   * The AI model used to generate the image
   *
   * @generated from field: optional string model = 1;
   */
  model?: string;

  /**
   * The original prompt used for generation
   *
   * @generated from field: optional string prompt = 2;
   */
  prompt?: string;

  /**
   * The revised prompt (for providers that revise prompts like DALL-E)
   *
   * @generated from field: optional string revised_prompt = 3;
   */
  revisedPrompt?: string;

  /**
   * The aspect ratio used (for providers that support it)
   *
   * @generated from field: optional string aspect_ratio = 4;
   */
  aspectRatio?: string;
};

/**
 * Describes the message chat.v3.ImageMetadata.
 * Use `create(ImageMetadataSchema)` to create a new message.
 */
export const ImageMetadataSchema: GenMessage<ImageMetadata> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 23);

/**
 * ConceptSummary represents a single concept
 *
 * @generated from message chat.v3.ConceptSummary
 */
export type ConceptSummary = Message$1<"chat.v3.ConceptSummary"> & {
  /**
   * The unique identifier for the concept
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The name of the concept
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Brief summary of the concept
   *
   * @generated from field: string summary = 3;
   */
  summary: string;

  /**
   * Full description of the concept
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * Optional category or domain
   *
   * @generated from field: string domain = 5;
   */
  domain: string;
};

/**
 * Describes the message chat.v3.ConceptSummary.
 * Use `create(ConceptSummarySchema)` to create a new message.
 */
export const ConceptSummarySchema: GenMessage<ConceptSummary> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 24);

/**
 * FeatureMetrics contains the accounting data for a specific feature
 *
 * @generated from message chat.v3.FeatureMetrics
 */
export type FeatureMetrics = Message$1<"chat.v3.FeatureMetrics"> & {
  /**
   * The number of tokens received from the feature
   *
   * @generated from field: uint64 ingress_tokens = 1;
   */
  ingressTokens: bigint;

  /**
   * The number of tokens sent to the feature
   *
   * @generated from field: uint64 egress_tokens = 2;
   */
  egressTokens: bigint;

  /**
   * The number of ingress bytes received for the operation
   *
   * @generated from field: uint64 ingress_bytes = 3;
   */
  ingressBytes: bigint;

  /**
   * The number of egress bytes sent for the operation
   *
   * @generated from field: uint64 egress_bytes = 4;
   */
  egressBytes: bigint;
};

/**
 * Describes the message chat.v3.FeatureMetrics.
 * Use `create(FeatureMetricsSchema)` to create a new message.
 */
export const FeatureMetricsSchema: GenMessage<FeatureMetrics> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 25);

/**
 * MessageTaskData represents the data associated with task operations
 *
 * @generated from message chat.v3.MessageTaskData
 */
export type MessageTaskData = Message$1<"chat.v3.MessageTaskData"> & {
  /**
   * Unique identifier for the task
   * Format: ^task_[a-z0-9]{20}$
   *
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * Human-readable task name/title
   *
   * @generated from field: string task_name = 2;
   */
  taskName: string;

  /**
   * Current status of the task
   *
   * @generated from field: chat.v3.TaskStatus status = 3;
   */
  status: TaskStatus;

  /**
   * Progress percentage (0-100)
   *
   * @generated from field: int32 progress_percent = 4;
   */
  progressPercent: number;

  /**
   * Optional description of current activity
   *
   * @generated from field: optional string current_activity = 5;
   */
  currentActivity?: string;

  /**
   * Dependencies - other task IDs this task depends on
   *
   * @generated from field: repeated string dependencies = 6;
   */
  dependencies: string[];

  /**
   * Task metadata (tool calls, parameters, etc.)
   *
   * @generated from field: map<string, string> metadata = 7;
   */
  metadata: { [key: string]: string };

  /**
   * Error information if task failed
   *
   * @generated from field: optional string error_message = 8;
   */
  errorMessage?: string;

  /**
   * Duration estimates from activity schemas
   *
   * @generated from field: optional chat.v3.TaskDurationInfo duration_info = 9;
   */
  durationInfo?: TaskDurationInfo;

  /**
   * Icon representing the task type or status
   *
   * @generated from field: optional common.v3.Icon icon = 10;
   */
  icon?: Icon;
};

/**
 * Describes the message chat.v3.MessageTaskData.
 * Use `create(MessageTaskDataSchema)` to create a new message.
 */
export const MessageTaskDataSchema: GenMessage<MessageTaskData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 26);

/**
 * TaskDurationInfo provides comprehensive timing information for tasks
 *
 * @generated from message chat.v3.TaskDurationInfo
 */
export type TaskDurationInfo = Message$1<"chat.v3.TaskDurationInfo"> & {
  /**
   * Expected duration in milliseconds (from schema)
   *
   * @generated from field: uint64 expected_duration_ms = 1;
   */
  expectedDurationMs: bigint;

  /**
   * Minimum expected duration in milliseconds (from schema)
   *
   * @generated from field: optional uint64 min_duration_ms = 2;
   */
  minDurationMs?: bigint;

  /**
   * Maximum expected duration in milliseconds (from schema)
   *
   * @generated from field: optional uint64 max_duration_ms = 3;
   */
  maxDurationMs?: bigint;

  /**
   * Task category (e.g., "search", "analysis", "generation")
   *
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * Confidence level ("high", "medium", "low")
   *
   * @generated from field: string confidence = 5;
   */
  confidence: string;

  /**
   * Whether the task runs synchronously or asynchronously
   *
   * @generated from field: bool is_synchronous = 6;
   */
  isSynchronous: boolean;

  /**
   * Human-readable description of what the task does
   *
   * @generated from field: string description = 7;
   */
  description: string;
};

/**
 * Describes the message chat.v3.TaskDurationInfo.
 * Use `create(TaskDurationInfoSchema)` to create a new message.
 */
export const TaskDurationInfoSchema: GenMessage<TaskDurationInfo> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 27);

/**
 * MessageOperationStatusData represents operational status for any activity
 *
 * @generated from message chat.v3.MessageOperationStatusData
 */
export type MessageOperationStatusData = Message$1<"chat.v3.MessageOperationStatusData"> & {
  /**
   * Unique identifier for the operation
   * Format: ^operation_[a-z0-9]{20}$
   *
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * System activity key
   *
   * @generated from field: string activity = 2;
   */
  activity: string;

  /**
   * Human-readable name of the operation
   *
   * @generated from field: string operation_name = 3;
   */
  operationName: string;

  /**
   * Current status of the operation
   *
   * @generated from field: chat.v3.OperationStatus status = 4;
   */
  status: OperationStatus;

  /**
   * Parent operation ID for nested operations (e.g., tool calls within a task)
   * Format: ^operation_[a-z0-9]{20}$
   *
   * @generated from field: optional string parent_operation_id = 5;
   */
  parentOperationId?: string;

  /**
   * Current activity description (e.g., "Analyzing user intent...", "Searching knowledge base...")
   *
   * @generated from field: optional string progress_message = 6;
   */
  progressMessage?: string;

  /**
   * Timing information
   *
   * @generated from field: google.protobuf.Timestamp started_at = 7;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 8;
   */
  completedAt?: Timestamp;
};

/**
 * Describes the message chat.v3.MessageOperationStatusData.
 * Use `create(MessageOperationStatusDataSchema)` to create a new message.
 */
export const MessageOperationStatusDataSchema: GenMessage<MessageOperationStatusData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 28);

/**
 * MessageInsightData represents the data associated with an insight event.
 *
 * @generated from message chat.v3.MessageInsightData
 */
export type MessageInsightData = Message$1<"chat.v3.MessageInsightData"> & {
  /**
   * Unique identifier for the insight
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Human-readable label for the insight
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * Arbitrary key-value data for the insight
   *
   * @generated from field: map<string, string> values = 3;
   */
  values: { [key: string]: string };
};

/**
 * Describes the message chat.v3.MessageInsightData.
 * Use `create(MessageInsightDataSchema)` to create a new message.
 */
export const MessageInsightDataSchema: GenMessage<MessageInsightData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_messages, 29);

/**
 * @generated from enum chat.v3.Role
 */
export enum Role {
  /**
   * @generated from enum value: ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Indicates a user generated the message. Users may be human or agents.
   *
   * @generated from enum value: ROLE_USER = 1;
   */
  USER = 1,

  /**
   * Indicates a system generated the message which may be an error, warning,
   * or other information message. System messages are not user generated
   * and are not AI responses.
   *
   * @generated from enum value: ROLE_SYSTEM = 2;
   */
  SYSTEM = 2,

  /**
   * Indicates an AI response.
   *
   * @generated from enum value: ROLE_ASSISTANT = 4;
   */
  ASSISTANT = 4,

  /**
   * Indicates a specialized agent has responded to this message.
   *
   * @generated from enum value: ROLE_AGENT = 11;
   */
  AGENT = 11,

  /**
   * Indicates this message is from a tools or service that was called to
   * perform an action or generate content.
   *
   * @generated from enum value: ROLE_TOOL = 12;
   */
  TOOL = 12,

  /**
   * Indicates this message was the result of a function call or responses.
   *
   * @generated from enum value: ROLE_FUNCTION = 13;
   */
  FUNCTION = 13,
}

/**
 * Describes the enum chat.v3.Role.
 */
export const RoleSchema: GenEnum<Role> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 0);

/**
 * @generated from enum chat.v3.Event
 */
export enum Event {
  /**
   * EVENT_UNSPECIFIED represents the default value when no event
   * type is specified. Should not be used.
   *
   * @generated from enum value: EVENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * EVENT_MESSAGE_PING is a heartbeat event to maintain an active connection
   * when streaming messages. This is used to keep the connection alive and is
   * not a message users need to be made aware of. A ping is sent when no other
   * message is streamed for a period of time. Pings are not recorded in a
   * conversation history and will not be present when a streamed conversation
   * is loaded such as when refreshing the browser or revisiting a conversation
   * from yesterday.
   *
   * @generated from enum value: EVENT_MESSAGE_PING = 1;
   */
  MESSAGE_PING = 1,

  /**
   * EVENT_MESSAGE_ERROR indicates an error occurred during message processing
   * May be returned for streaming messages and when completed messages are
   * loaded such as when refreshing the browser.
   *
   * @generated from enum value: EVENT_MESSAGE_ERROR = 2;
   */
  MESSAGE_ERROR = 2,

  /**
   * EVENT_MESSAGE_WARNING indicates a non-fatal issue or warning condition.
   * May be returned for streaming messages and when completed messages are
   * loaded such as when refreshing the browser.
   *
   * @generated from enum value: EVENT_MESSAGE_WARNING = 3;
   */
  MESSAGE_WARNING = 3,

  /**
   * EVENT_MESSAGE_LIMIT provides an update on rate limits or quotas which
   * may be something like "14% used" or "resource has been exhausted".
   * May be returned for streaming messages and when completed messages are
   * loaded such as when refreshing the browser.
   *
   * @generated from enum value: EVENT_MESSAGE_LIMIT = 4;
   */
  MESSAGE_LIMIT = 4,

  /**
   * EVENT_MESSAGE_CANCEL indicates the message processing was canceled.
   * May be returned for streaming messages and when completed messages are
   * loaded such as when refreshing the browser.
   *
   * @generated from enum value: EVENT_MESSAGE_CANCEL = 5;
   */
  MESSAGE_CANCEL = 5,

  /**
   * EVENT_MESSAGE_RETRY indicates a retry of a operation.
   * May be returned for streaming messages and when completed messages are
   * loaded such as when refreshing the browser.
   *
   * @generated from enum value: EVENT_MESSAGE_RETRY = 6;
   */
  MESSAGE_RETRY = 6,

  /**
   * EVENT_PROMPT indicates a prompt that was sent for processing.
   * This type is returned when accessing a conversation that has been
   * previously streamed such as when reloading the browser or revisiting a
   * conversation from yesterday.
   *
   * @generated from enum value: EVENT_PROMPT = 100;
   */
  PROMPT = 100,

  /**
   * EVENT_ACTION_TAKEN indicates an action that was taken. This could be
   * by the user in response to a suggested action or an action taken by
   * the system in a workflow.
   *
   * @generated from enum value: EVENT_ACTION_TAKEN = 101;
   */
  ACTION_TAKEN = 101,

  /**
   * EVENT_MESSAGE indicates an entire message.
   * This type is returned when accessing a conversation that has been
   * previously streamed such as when reloading the browser or revisiting a
   * conversation from yesterday.
   *
   * @generated from enum value: EVENT_MESSAGE = 102;
   */
  MESSAGE = 102,

  /**
   * EVENT_BLOCK indicates an entire block. A message may contain zero
   * or more blocks. All blocks are contained within a message.
   * This type is returned when accessing a conversation that has been
   * previously streamed such as when reloading the browser or revisiting a
   * conversation from yesterday.
   *
   * @generated from enum value: EVENT_BLOCK = 103;
   */
  BLOCK = 103,

  /**
   * EVENT_MESSAGE_START indicates the beginning of a new streaming message.
   * Additional events will follow such as EVENT_MESSAGE_DELTA and EVENT_MESSAGE_STOP.
   * Additionally, additional EVENT_MESSAGE_BLOCK_* events may be sent
   * before EVENT_MESSAGE_STOP.
   *
   * @generated from enum value: EVENT_MESSAGE_START = 1000;
   */
  MESSAGE_START = 1000,

  /**
   * EVENT_MESSAGE_DELTA provides an incremental content update for a
   * streaming message. Deltas will always be plain-text/markdown.
   * to a message.
   *
   * @generated from enum value: EVENT_MESSAGE_DELTA = 1001;
   */
  MESSAGE_DELTA = 1001,

  /**
   * EVENT_MESSAGE_STOP indicates the message generation is complete for steamed
   * messages. This is the last event sent and indicates
   * that the turn is over.
   *
   * When processing a rich text message, the entire message for the
   * index will be sent as rich text. This allows a rich text client to
   * incrementally show progress to a user before swapping the entire message
   * for a rich text document complete with encoded meta data.
   *
   * @generated from enum value: EVENT_MESSAGE_STOP = 1002;
   */
  MESSAGE_STOP = 1002,

  /**
   * EVENT_MESSAGE_BLOCK_START indicates the beginning of a content block
   * for a streaming message. A block is a sub-part of a message and may be
   * used to provide additional context, used for formatting, or relay other
   * information. All blocks are contained within messages.
   *
   * @generated from enum value: EVENT_MESSAGE_BLOCK_START = 1003;
   */
  MESSAGE_BLOCK_START = 1003,

  /**
   * EVENT_MESSAGE_BLOCK_DELTA provides an incremental update for the
   * current block in a streaming message. Incremental updates will always
   * be plain-text/markdown.
   *
   * @generated from enum value: EVENT_MESSAGE_BLOCK_DELTA = 1004;
   */
  MESSAGE_BLOCK_DELTA = 1004,

  /**
   * EVENT_MESSAGE_BLOCK_STOP indicates the block generation is complete
   * for a streamed message.
   *
   * When processing a rich text message, the entire block will be sent as
   * rich text. This allows a rich text client to incrementally show
   * progress to a user before swapping the entire block for a rich text
   * representation complete with encoded meta data.
   *
   * @generated from enum value: EVENT_MESSAGE_BLOCK_STOP = 1005;
   */
  MESSAGE_BLOCK_STOP = 1005,

  /**
   * EVENT_MESSAGE_BLOCK_GENERATION_START indicates the start of a block
   * that is generating content. This may be for the generation of
   * instructions to be used by a model or tool or for the generation
   * of artifacts such as images, audio, or other content.
   *
   * @generated from enum value: EVENT_MESSAGE_BLOCK_GENERATION_START = 1006;
   */
  MESSAGE_BLOCK_GENERATION_START = 1006,

  /**
   * EVENT_MESSAGE_BLOCK_GENERATION_DELTA provides an incremental update
   * for the current block that is generating content.
   *
   * @generated from enum value: EVENT_MESSAGE_BLOCK_GENERATION_DELTA = 1007;
   */
  MESSAGE_BLOCK_GENERATION_DELTA = 1007,

  /**
   * EVENT_MESSAGE_BLOCK_GENERATION_STOP indicates the block generation
   * is complete for a streamed message.
   *
   * @generated from enum value: EVENT_MESSAGE_BLOCK_GENERATION_STOP = 1008;
   */
  MESSAGE_BLOCK_GENERATION_STOP = 1008,

  /**
   * EVENT_OPERATION_START indicates the beginning of an operation
   *
   * @generated from enum value: EVENT_OPERATION_START = 10000;
   */
  OPERATION_START = 10000,

  /**
   * EVENT_OPERATION_PROGRESS provides incremental updates during operation execution
   *
   * @generated from enum value: EVENT_OPERATION_PROGRESS = 10001;
   */
  OPERATION_PROGRESS = 10001,

  /**
   * EVENT_OPERATION_COMPLETE indicates successful operation completion
   *
   * @generated from enum value: EVENT_OPERATION_COMPLETE = 10002;
   */
  OPERATION_COMPLETE = 10002,

  /**
   * EVENT_OPERATION_FAILED indicates operation failed with error details
   *
   * @generated from enum value: EVENT_OPERATION_FAILED = 10003;
   */
  OPERATION_FAILED = 10003,

  /**
   * EVENT_OPERATION_CANCELLED indicates operation was cancelled before completion
   *
   * @generated from enum value: EVENT_OPERATION_CANCELLED = 10004;
   */
  OPERATION_CANCELLED = 10004,

  /**
   * EVENT_INSIGHT is used to send discovered insights, detected concepts, etc.
   * This event is only sent by itself, not as part of a start/delta/stop sequence.
   *
   * @generated from enum value: EVENT_INSIGHT = 11000;
   */
  INSIGHT = 11000,
}

/**
 * Describes the enum chat.v3.Event.
 */
export const EventSchema: GenEnum<Event> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 1);

/**
 * @generated from enum chat.v3.MessageType
 */
export enum MessageType {
  /**
   * @generated from enum value: MESSAGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * MESSAGE_TYPE_PROMPT_ACK is typically the first message sent when
   * processing begins and is an acknowledgment that the prompt has been
   * received and processing has started.
   *
   * @generated from enum value: MESSAGE_TYPE_PROMPT_ACK = 1;
   */
  PROMPT_ACK = 1,

  /**
   * MESSAGE_TYPE_INTERSTITIAL indicates a message that is in-between
   * other more important messages. This is often used to provide feedback to
   * the user that the system is processing and what steps are being taken.
   *
   * Interstitial messages recorded; however, under normal circumstances they
   * are not returned when a conversation is reloaded such as when visiting
   * a conversation from yesterday or reloading your browser. When diagnostic
   * tools are enabled these messages will be returned with history.
   * Examples:
   * - Processing your query...
   * - Searching weather database for San Francisco.
   *
   * @generated from enum value: MESSAGE_TYPE_INTERSTITIAL = 2;
   */
  INTERSTITIAL = 2,

  /**
   * @generated from enum value: MESSAGE_TYPE_INTERSTITIAL_DATA = 3;
   */
  INTERSTITIAL_DATA = 3,

  /**
   * @generated from enum value: MESSAGE_TYPE_INTERSTITIAL_USER_FACING = 4;
   */
  INTERSTITIAL_USER_FACING = 4,

  /**
   * MESSAGE_TYPE_INTERSTITIAL_CATCH is used to transmit data from a model
   * if it responds outside of the expected format.
   *
   * @generated from enum value: MESSAGE_TYPE_INTERSTITIAL_CATCH = 6;
   */
  INTERSTITIAL_CATCH = 6,

  /**
   * MESSAGE_TYPE_SCOPED provides feedback as to the scope of knowledge that
   * may be used to process the prompt. This is the net that has been cast to
   * find the information needed to answer the prompt. Said differently, the
   * boundary of the knowledge that is being used to answer the prompt.
   *
   * @generated from enum value: MESSAGE_TYPE_SCOPED = 100;
   */
  SCOPED = 100,

  /**
   * MESSAGE_TYPE_REFERENCED indicates what knowledge from scope was actually
   * used provided to a model. For example, if all knowledge labeled with
   * "#foo" was within scope and six pieces of knowledge were referenced
   * out of a pool of 100 pieces of knowledge, this message would indicate
   * the six pieces of knowledge that were actually made available as
   * references.
   *
   * @generated from enum value: MESSAGE_TYPE_REFERENCED = 200;
   */
  REFERENCED = 200,

  /**
   * MESSAGE_TYPE_RATE_FEEDBACK acknowledges feedback or a rating from a user
   * regarding the quality or relevance of a message. This feedback may
   * be used to improve the system's performance or to adjust the
   * response generation process. It is not used for training third-party
   * models.
   *
   * @generated from enum value: MESSAGE_TYPE_RATE_FEEDBACK = 300;
   */
  RATE_FEEDBACK = 300,

  /**
   * MESSAGE_TYPE_SYSTEM_STATUS provides information about the system's
   * current state, performance, or any issues that may be affecting
   * its operation. This message type is used to communicate
   * operational status updates, maintenance notifications,
   * or other relevant system information to users.
   *
   * System status messages recorded; however, under normal circumstances they
   * are not returned when a conversation is reloaded such as when visiting
   * a conversation from yesterday or reloading your browser. When diagnostic
   * tools are enabled these messages will be returned with history.
   *
   * @generated from enum value: MESSAGE_TYPE_SYSTEM_STATUS = 400;
   */
  SYSTEM_STATUS = 400,

  /**
   * MESSAGE_TYPE_MEMORY_UPDATE indicates a detail from a prompt was
   * added to memory. This is used to personalize the experience for the user
   * and may be used to provide a more relevant response in the future.
   *
   * @generated from enum value: MESSAGE_TYPE_MEMORY_UPDATE = 500;
   */
  MEMORY_UPDATE = 500,

  /**
   * MESSAGE_TYPE_TASK_CREATE indicates a task has been created.
   *
   * @generated from enum value: MESSAGE_TYPE_TASK_CREATE = 600;
   */
  TASK_CREATE = 600,

  /**
   * MESSAGE_TYPE_TASK_UPDATE indicates a task has been updated.
   *
   * @generated from enum value: MESSAGE_TYPE_TASK_UPDATE = 601;
   */
  TASK_UPDATE = 601,

  /**
   * MESSAGE_TYPE_OPERATION_STATUS provides operation lifecycle information
   * for activities like triage, intent analysis, strategy planning, and web search.
   * These messages track the complete lifecycle of operations independent of blocks.
   *
   * @generated from enum value: MESSAGE_TYPE_OPERATION_STATUS = 700;
   */
  OPERATION_STATUS = 700,

  /**
   * MESSAGE_TYPE_CONTENT is the primary content message type.
   *
   * Example: "The average temperature in San Francisco is 57°F (14°C) annually,
   * with September typically being the warmest month."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT = 1000;
   */
  CONTENT = 1000,

  /**
   * MESSAGE_TYPE_CONTENT_EXPLANATION indicates explanatory content that
   * supports answers or responses by providing reasoning, limitations,
   * additional considerations, or methodological details.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "This temperature data is based on 30-year averages from NOAA
   * and may not reflect recent climate trends. Microclimates within the city
   * can vary by 5-10°F."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_EXPLANATION = 1001;
   */
  CONTENT_EXPLANATION = 1001,

  /**
   * MESSAGE_TYPE_CONTENT_CITATION provides attribution information for sources,
   * references, or evidence that supports the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "Data source: National Oceanic and Atmospheric Administration,
   * Climate.gov, 'San Francisco Climate Data 1991-2020', accessed April 2025."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_CITATION = 1002;
   */
  CONTENT_CITATION = 1002,

  /**
   * MESSAGE_TYPE_CONTENT_SUMMARY provides a condensed version of longer content,
   * highlighting key points or conclusions.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "San Francisco enjoys mild temperatures year-round with
   * minimal seasonal variation compared to other U.S. cities."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_SUMMARY = 1003;
   */
  CONTENT_SUMMARY = 1003,

  /**
   * MESSAGE_TYPE_CONTENT_DISCLAIMER contains important caveats, limitations, or
   * legal notices that users should be aware of regarding the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "This information is provided for general reference only and
   * should not be used for critical weather-dependent planning without
   * consulting local forecasts."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_DISCLAIMER = 1004;
   */
  CONTENT_DISCLAIMER = 1004,

  /**
   * MESSAGE_TYPE_CONTENT_ALTERNATIVE presents different options, approaches, or
   * interpretations to the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "Alternative measurement: Using the heat index that accounts for
   * humidity, San Francisco's 'feels like' temperature is often lower than
   * the actual reading."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_ALTERNATIVE = 1005;
   */
  CONTENT_ALTERNATIVE = 1005,

  /**
   * MESSAGE_TYPE_CONTENT_ELABORATION provides additional details, examples, or
   * extended information that builds upon the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "The city's famous fog, locally nicknamed 'Karl', contributes
   * significantly to temperature regulation, especially during summer months
   * when inland areas experience much higher temperatures."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_ELABORATION = 1006;
   */
  CONTENT_ELABORATION = 1006,

  /**
   * MESSAGE_TYPE_CONTENT_PREREQUISITE contains background information or concepts
   * necessary to understand the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "Temperature in meteorology is measured using either
   * Fahrenheit (°F) or Celsius (°C) scales, with the latter being standard
   * in scientific contexts and most countries outside the United States."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_PREREQUISITE = 1007;
   */
  CONTENT_PREREQUISITE = 1007,

  /**
   * MESSAGE_TYPE_CONTENT_CLARIFICATION addresses potential misunderstandings or
   * ambiguities in the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "To clarify, when we reference 'San Francisco temperatures',
   * we're measuring at the official weather station located near downtown,
   * not at coastal areas which can be significantly cooler."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_CLARIFICATION = 1008;
   */
  CONTENT_CLARIFICATION = 1008,

  /**
   * MESSAGE_TYPE_CONTENT_NEXT_STEPS suggests actions, further reading, or follow-up
   * items related to the primary content.
   *
   * Content of this nature may may naturally appear within
   * MESSAGE_TYPE_CONTENT. However, it will be discreetly this content type
   * when generated as part of a prepared plan or by a user when they
   * request for an entire message or a specific section of a message.
   *
   * Example: "For more detailed climate information, check the SF Microclimate
   * Map or subscribe to neighborhood-specific weather alerts through the city's
   * notification system."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_NEXT_STEPS = 1009;
   */
  CONTENT_NEXT_STEPS = 1009,

  /**
   * MESSAGE_TYPE_CONTENT_ERROR_CORRECTION identifies and fixes mistakes in
   * previously delivered content.
   *
   * This content may may naturally appear within MESSAGE_TYPE_CONTENT or may be
   * specifically requested when executing a prepared plan or by a user when
   * interacting with an entire message or a specific section of a message.
   *
   * Example: "Correction: In our previous message, we stated that October was
   * the warmest month in San Francisco. The warmest month is actually
   * September, with an average high of 71°F (22°C)."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_ERROR_CORRECTION = 1010;
   */
  CONTENT_ERROR_CORRECTION = 1010,

  /**
   * MESSAGE_TYPE_CONTENT_WALKTHROUGH provides step-by-step guidance related to
   * the primary content, often used for tutorials or instructions.
   *
   * This content may may naturally appear within MESSAGE_TYPE_CONTENT or may be
   * specifically requested when executing a prepared plan or by a user when
   * interacting with an entire message or a specific section of a message.
   *
   * Example: "To convert Fahrenheit to Celsius: 1) Subtract 32 from the
   * temperature, 2) Multiply by 5, 3) Divide by 9. For example, 57°F:
   * (57-32)×5÷9 = 14°C."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_WALKTHROUGH = 1011;
   */
  CONTENT_WALKTHROUGH = 1011,

  /**
   * MESSAGE_TYPE_CONTENT_TECHNICAL_DETAILS contains specialized information
   * like specifications, parameters, or implementation details supporting the
   * main content.
   *
   * This content may may naturally appear within MESSAGE_TYPE_CONTENT or may be
   * specifically requested when executing a prepared plan or by a user when
   * interacting with an entire message or a specific section of a message.
   *
   * Example: "Temperature sensors used in San Francisco's weather stations are
   * RTD PT100 models with ±0.1°C accuracy, calibrated quarterly, and placed 2
   * meters above ground level in ventilated enclosures."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_TECHNICAL_DETAILS = 1012;
   */
  CONTENT_TECHNICAL_DETAILS = 1012,

  /**
   * MESSAGE_TYPE_CONTENT_HISTORICAL_CONTEXT provides temporal background or evolution
   * of concepts mentioned in the primary content.
   *
   * This content may may naturally appear within MESSAGE_TYPE_CONTENT or may be
   * specifically requested when executing a prepared plan or by a user when
   * interacting with an entire message or a specific section of a message.
   *
   * Example: "San Francisco's temperature records date back to 1849, showing
   * that average temperatures have increased by approximately 1.7°F over the
   * past century, with most of that change occurring after 1980."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_HISTORICAL_CONTEXT = 1013;
   */
  CONTENT_HISTORICAL_CONTEXT = 1013,

  /**
   * MESSAGE_TYPE_CONTENT_COMPARISON contrasts different elements, approaches, or
   * solutions related to the primary content.
   *
   * This content may may naturally appear within MESSAGE_TYPE_CONTENT or may be
   * specifically requested when executing a prepared plan or by a user when
   * interacting with an entire message or a specific section of a message.
   *
   * Example: "While San Francisco averages 57°F annually, nearby cities show
   * significant differences: Oakland averages 63°F, Pacifica 55°F, and San Jose
   * 70°F, demonstrating the Bay Area's dramatic microclimate variations."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_COMPARISON = 1014;
   */
  CONTENT_COMPARISON = 1014,

  /**
   * MESSAGE_TYPE_CONTENT_EXAMPLE illustrates concepts from the primary content
   * with concrete instances or sample implementations.
   *
   * This content may may naturally appear within MESSAGE_TYPE_CONTENT or may be
   * specifically requested when executing a prepared plan or by a user when
   * interacting with an entire message or a specific section of a message.
   *
   * Example: "As an example of San Francisco's temperature consistency, on July 12, 2024,
   * downtown recorded a high of 65°F while Phoenix reached 112°F and Chicago 91°F on the
   * same day."
   *
   * @generated from enum value: MESSAGE_TYPE_CONTENT_EXAMPLE = 1015;
   */
  CONTENT_EXAMPLE = 1015,

  /**
   * MESSAGE_TYPE_DATA_VISUALIZATION indicates a message that is used to
   * visualize data such as drawing a chart or graph.
   *
   * This content won't appear naturally appear within MESSAGE_TYPE_CONTENT.
   * It will be discreetly this content type when generated as part of a
   * prepared plan or by a user when they request for an entire message
   * or a specific section of a message.
   *
   * Example (but rendered as a chart from structured data):
   *
   * "AAPL Stock Price (Last 30 Days)
   *
   *  $215 |                                     *
   *       |                            *      *   *
   *  $210 |                      *   *   *  *
   *       |               *    *  *
   *  $205 |         *   *  *
   *       |       *  *
   *  $200 |    *
   *       |  *
   *  $195 |*
   *       +--------------------------------------
   *        01  05  10  15  20  25  30  APR 2025
   *
   * Trading Volume (millions)
   *    30 |   |  |
   *    20 |   |  |     |  |     |  |  |     |
   *    10 ||| | || ||| | || ||| | || | ||| ||
   *       +--------------------------------------"
   *
   * @generated from enum value: MESSAGE_TYPE_DATA_VISUALIZATION = 1016;
   */
  DATA_VISUALIZATION = 1016,

  /**
   * MESSAGE_TYPE_SUGGESTED_ACTION indicates a message that is used to
   * suggest an action to the user.
   *
   * This content won't appear naturally appear within MESSAGE_TYPE_CONTENT.
   * It will be discreetly this content type when generated as part of a
   * prepared plan or by a user when they request for an entire message
   * or a specific section of a message.
   *
   * Example: "Do you want to [ SAVE ] or [ SHARE ] this message?"
   *
   * @generated from enum value: MESSAGE_TYPE_SUGGESTED_ACTION = 1017;
   */
  SUGGESTED_ACTION = 1017,

  /**
   * MESSAGE_TYPE_CLARIFICATION_REQUEST indicates a message that is used to
   * request clarification from the user.
   *
   * @generated from enum value: MESSAGE_TYPE_CLARIFICATION_REQUEST = 1018;
   */
  CLARIFICATION_REQUEST = 1018,

  /**
   * MESSAGE_TYPE_ARTIFACT_CREATION indicates a message that is used to
   * generate an artifact such as an image, audio, or other content.
   *
   * @generated from enum value: MESSAGE_TYPE_ARTIFACT_CREATION = 1019;
   */
  ARTIFACT_CREATION = 1019,

  /**
   * MESSAGE_TYPE_ARTIFACT_REVISION indicates a message that is used to
   * revise an artifact such as an image, audio, or other content.
   *
   * @generated from enum value: MESSAGE_TYPE_ARTIFACT_REVISION = 1020;
   */
  ARTIFACT_REVISION = 1020,

  /**
   * MESSAGE_TYPE_CHAT_SEARCH_RESULTS carries a search_chats tool result payload
   * (JSON in MessageData.Text) that the frontend renders as an inline card.
   *
   * @generated from enum value: MESSAGE_TYPE_CHAT_SEARCH_RESULTS = 1021;
   */
  CHAT_SEARCH_RESULTS = 1021,

  /**
   * MESSAGE_TYPE_SKILLS carries the body of a loaded skill (persona instructions
   * or playbook text) as a JSON payload in MessageData.Text. The frontend renders
   * it as a "skill loaded" affordance; extractors must exclude it from
   * assistant response text so it does not pollute search indexing, @-chat
   * references, or load_chat transcripts with the skill body.
   *
   * @generated from enum value: MESSAGE_TYPE_SKILLS = 1022;
   */
  SKILLS = 1022,
}

/**
 * Describes the enum chat.v3.MessageType.
 */
export const MessageTypeSchema: GenEnum<MessageType> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 2);

/**
 * OperationStatus represents the current state of an operation
 *
 * @generated from enum chat.v3.OperationStatus
 */
export enum OperationStatus {
  /**
   * @generated from enum value: OPERATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Operation is starting up
   *
   * @generated from enum value: OPERATION_STATUS_STARTING = 1;
   */
  STARTING = 1,

  /**
   * Operation is actively running
   *
   * @generated from enum value: OPERATION_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * Operation completed successfully
   *
   * @generated from enum value: OPERATION_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * Operation failed with an error
   *
   * @generated from enum value: OPERATION_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * Operation was cancelled
   *
   * @generated from enum value: OPERATION_STATUS_CANCELLED = 5;
   */
  CANCELLED = 5,

  /**
   * Operation is retrying after a failure
   *
   * @generated from enum value: OPERATION_STATUS_RETRYING = 6;
   */
  RETRYING = 6,
}

/**
 * Describes the enum chat.v3.OperationStatus.
 */
export const OperationStatusSchema: GenEnum<OperationStatus> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 3);

/**
 * ActivityType represents the type of activity being performed
 *
 * @generated from enum chat.v3.ActivityType
 */
export enum ActivityType {
  /**
   * @generated from enum value: ACTIVITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACTIVITY_TYPE_TRIAGE = 1;
   */
  TRIAGE = 1,

  /**
   * @generated from enum value: ACTIVITY_TYPE_INTENT_ANALYSIS = 2;
   */
  INTENT_ANALYSIS = 2,

  /**
   * @generated from enum value: ACTIVITY_TYPE_STRATEGY_PLANNING = 3;
   */
  STRATEGY_PLANNING = 3,

  /**
   * @generated from enum value: ACTIVITY_TYPE_WEB_SEARCH = 4;
   */
  WEB_SEARCH = 4,

  /**
   * @generated from enum value: ACTIVITY_TYPE_CONTENT_GENERATION = 5;
   */
  CONTENT_GENERATION = 5,

  /**
   * @generated from enum value: ACTIVITY_TYPE_DOCUMENT_PROCESSING = 6;
   */
  DOCUMENT_PROCESSING = 6,
}

/**
 * Describes the enum chat.v3.ActivityType.
 */
export const ActivityTypeSchema: GenEnum<ActivityType> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 4);

/**
 * @generated from enum chat.v3.FeatureTokenType
 */
export enum FeatureTokenType {
  /**
   * @generated from enum value: FEATURE_TOKEN_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * FEATURE_TOKEN_TYPE_ACCUMULATE indicates tokens should be accumulated by
   * a client.
   *
   * @generated from enum value: FEATURE_TOKEN_TYPE_ACCUMULATE = 1;
   */
  ACCUMULATE = 1,

  /**
   * FEATURE_TOKEN_TYPE_FINAL indicates tokens are final and can replace
   * accumulated tokens.
   *
   * @generated from enum value: FEATURE_TOKEN_TYPE_FINAL = 2;
   */
  FINAL = 2,

  /**
   * FEATURE_TOKEN_TYPE_ACCUMULATED indicates tokens are accumulated by the
   * server and a client need not accumulate them.
   *
   * @generated from enum value: FEATURE_TOKEN_TYPE_ACCUMULATED = 3;
   */
  ACCUMULATED = 3,
}

/**
 * Describes the enum chat.v3.FeatureTokenType.
 */
export const FeatureTokenTypeSchema: GenEnum<FeatureTokenType> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 5);

/**
 * TaskStatus represents the current state of a task
 *
 * @generated from enum chat.v3.TaskStatus
 */
export enum TaskStatus {
  /**
   * @generated from enum value: TASK_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Task has been planned but not yet started
   *
   * @generated from enum value: TASK_STATUS_PLANNED = 1;
   */
  PLANNED = 1,

  /**
   * Task is currently being executed
   *
   * @generated from enum value: TASK_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * Task has completed successfully
   *
   * @generated from enum value: TASK_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * Task encountered an error and failed
   *
   * @generated from enum value: TASK_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * Task was cancelled before completion
   *
   * @generated from enum value: TASK_STATUS_CANCELLED = 5;
   */
  CANCELLED = 5,

  /**
   * Task is waiting for dependencies to complete
   *
   * @generated from enum value: TASK_STATUS_BLOCKED = 6;
   */
  BLOCKED = 6,
}

/**
 * Describes the enum chat.v3.TaskStatus.
 */
export const TaskStatusSchema: GenEnum<TaskStatus> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_messages, 6);

